export enum BatchType {
    declaration = 'declaration',
    invoice = 'invoice',
    patientInvoice = 'patientInvoice',
    payout = 'payout',
    singularPatientInvoice = 'singularPatientInvoice',
}
